// Called only after the world tick has stopped, immediately before navigation.
export function disposeRoomGraphics(world) {
  const geometries = new Set()
  const materials = new Set()
  const textures = new Set()
  const targets = new Set()
  const addTexture = value => {
    if (value?.isTexture) textures.add(value)
    else if (Array.isArray(value)) value.forEach(addTexture)
  }
  const addMaterial = value => {
    if (Array.isArray(value)) return value.forEach(addMaterial)
    if (!value?.isMaterial || materials.has(value)) return
    materials.add(value)
    Object.values(value).forEach(addTexture)
    for (const uniform of Object.values(value.uniforms || {})) addTexture(uniform?.value)
  }
  world.stage.scene.traverse(object => {
    if (object.geometry) geometries.add(object.geometry)
    addMaterial(object.material)
    if (object.shadow?.map) targets.add(object.shadow.map)
    if (object.shadow?.mapPass) targets.add(object.shadow.mapPass)
  })
  world.environment.model?.traverse(node => {
    if (node._geometry) geometries.add(node._geometry)
    addMaterial(node._material)
  })
  addTexture(world.stage.scene.background)
  addTexture(world.stage.scene.environment)
  for (const value of world.loader.results.values()) addTexture(value)
  const activeEffects = new Set(world.graphics.effectPass?.effects || [])
  world.graphics.composer?.dispose()
  // Disabled effects may no longer belong to a pass but still own render targets.
  for (const effect of [world.graphics.bloom, world.graphics.smaa, world.graphics.tonemapping]) {
    if (effect && !activeEffects.has(effect)) effect.dispose()
  }
  for (const target of targets) target.dispose()
  for (const geometry of geometries) {
    geometry.disposeBoundsTree?.()
    geometry.dispose()
  }
  for (const material of materials) material.dispose()
  for (const texture of textures) texture.dispose()
  world.loader.destroy()
  world.stage.scene.background = null
  world.stage.scene.environment = null
  world.stage.scene.clear()
  world.stage.models.clear()
  world.environment.model = null
  return { geometries: geometries.size, materials: materials.size, textures: textures.size, shadowTargets: targets.size }
}
